module.exports = __webpack_public_path__ + "img/cancel.8ef62d27.png";